import React, { useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Channel from './Channel';
import { setPlayingChannel } from '../../actions/playingChannel';
import { FixedSizeList as List } from 'react-window';
import { useHistory, useLocation } from 'react-router-dom';
import Popup from '../Popup/Popup';
import {convertRemToPixels,convertVhToPixels} from "../../other/convert-rem"

const Channels = ({ playlist }) => {
    const playingChannel = useSelector((state) => state.playingCh);
    const query = useQuery();
    const searchText = query.get('search');

    const [showPopup, setShowPopup] = useState(false);
    const [channelsPlaylist, setChannelsPlaylist] = useState(playlist);

    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const listRef = useRef();

    useEffect(() => {
        if (playingChannel) {
            setTimeout(() => focusChannel(), 100);
        }
    }, [playingChannel]);

    useEffect(() => {
        setChannelsPlaylist(playlist);
        console.log('playlist', playlist);
        setTimeout(() => focusChannel(), 100);
    }, [playlist]);

    useEffect(() => {
        const searched = searchText
            ? playlist.filter((x) =>
                  x.name.toLowerCase().includes(searchText.toLowerCase())
              )
            : playlist;
        if (searched.length > 0) {
            setChannelsPlaylist(searched);
            setTimeout(() => focusChannel(), 100);
        } else if (searchText) {
            setShowPopup(true);
        } else {
            history.push('/live/category/');
        }
    }, [searchText, playlist, history]);

    const focusChannel = () => {
        const selectedCh = document.getElementById('selectedCh');
        const firstChannel = document.querySelector('.channel');
        if (selectedCh) {
            selectedCh.focus();
        } else if (firstChannel) {
            firstChannel.focus();
        }
    };

    const Row = ({ index, style }) => (
        <Channel
            key={channelsPlaylist[index].stream_id}
            Name={channelsPlaylist[index].name}
            Shift={channelsPlaylist[index].shift}
            Epg={channelsPlaylist[index].epg_channel_id}
            id={channelsPlaylist[index].stream_id}
            Image={channelsPlaylist[index].stream_icon}
            Number={channelsPlaylist[index].num}
            selectEvent={() => {
                dispatch(setPlayingChannel(channelsPlaylist[index]));
            }}
            virtualScrollStyle={style}
            selected={
                playingChannel &&
                playingChannel.stream_id === channelsPlaylist[index].stream_id
            }
        />
    );

    return (
        <>
                <List
                    height={convertVhToPixels('95vh') - convertRemToPixels(5)}
                    itemCount={channelsPlaylist.length}
                    itemSize={convertRemToPixels(5)}
                    style={{ overflowY: 'auto', maxHeight: 'calc(95vh - 3rem)' }}
                    useIsScrolling={true}
                    ref={listRef}
                >
                    {Row}
                </List>
            {showPopup && (
                <Popup
                    title={`No stream found with '${searchText}'`}
                    description={'Search will be reset.'}
                    icon={'fas fa-search'}
                    onclick={() => {
                        setShowPopup(false);
                        focusChannel();
                        history.replace(location.pathname.split('?')[0]);
                    }}
                />
            )}
        </>
    );
};

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

export default Channels;
